import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { initialize } from 'redux-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import formValueSelector from 'redux-form/es/formValueSelector';
import IdentDocumentsAU from 'components/Credit24/LoanApplication/IdentDocumentsAU';
import {
  identDocumentTypes,
  statesAU,
  medicareCardType,
} from 'consts';
import { useApplicationFlags } from 'hooks/useApplicationFlags';


import { removeActionError, getCountryList } from 'actions/loan';

const medicareReferenceNumbers = [...Array(9).keys()].map((i) => ({
  type: i + 1,
  title: i + 1,
}));

const drivingLicenceMinimumValidDate = moment();
const drivingLicenceMaximumValidDate = moment(drivingLicenceMinimumValidDate)
  .add(18, 'years')
  .endOf('year');

const medicareMinimumValidDate = moment().add(30, 'days');
const medicareMaximumValidDate = moment(medicareMinimumValidDate)
  .add(6, 'years')
  .endOf('year');
const passportMinimumValidDate = moment().add(30, 'days');
const passportMaximumValidDate = moment(passportMinimumValidDate)
  .add(11, 'years')
  .endOf('year');

const selector = formValueSelector('loan');

const IdentDocumentsAUContainer = (props) => {
  const dispatch = useDispatch();
  const { isOcmOrUpgrade } = useApplicationFlags();
  const countries = useSelector((state) => state.loan.countries);
  const isContentLoading = useSelector((state) => state.loan.isContentLoading);
  const prevDocumentTypeRef = useRef(props.selectedDocumentType);


  useEffect(() => {
    const shouldFetchCountries = !countries.length && !isContentLoading;

    if (shouldFetchCountries) {
      dispatch(getCountryList());
    }
  }, [dispatch, countries.length, isContentLoading]);

  useEffect(() => {
    if (isOcmOrUpgrade) return;

    const prev = prevDocumentTypeRef.current;
    const next = props.selectedDocumentType;
    if (prev && prev !== next) {
      dispatch(initialize('loan', { identDocumentType: next }));
    }
    prevDocumentTypeRef.current = next;
  }, [dispatch, props.selectedDocumentType]);

  return (
    <IdentDocumentsAU
      identDocumentTypes={identDocumentTypes}
      states={statesAU}
      medicareReferenceNumbers={medicareReferenceNumbers}
      medicalCardType={medicareCardType}
      countryOfIssue={countries}
      drivingLicenceMinimumValidDate={drivingLicenceMinimumValidDate}
      drivingLicenceMaximumValidDate={drivingLicenceMaximumValidDate}
      medicareMinimumValidDate={medicareMinimumValidDate}
      medicareMaximumValidDate={medicareMaximumValidDate}
      passportMinimumValidDate={passportMinimumValidDate}
      passportMaximumValidDate={passportMaximumValidDate}
      selectedDocumentType={props.selectedDocumentType}
      selectedCardColour={props.selectedCardColour}
      identFormError={props.identFormError}
      removeActionError={props.removeActionError}
      selectedDrivingLicenceState={props.selectedDrivingLicenceState}
    />
  );
};

IdentDocumentsAUContainer.propTypes = {
  selectedDocumentType: PropTypes.string,
  selectedCardColour: PropTypes.string,
  identFormError: PropTypes.bool,
  removeActionError: PropTypes.func,
  selectedDrivingLicenceState: PropTypes.string,
};

export default connect(
  (state) => ({
    selectedDocumentType: selector(state, 'identDocumentType'),
    selectedCardColour: selector(state, 'cardColour'),
    identFormError: state.loan.identDocumentError,
    selectedDrivingLicenceState: selector(state, 'drivingLicenceState'),
  }),
  { removeActionError }
)(IdentDocumentsAUContainer);
